import axios from './axios';
import utils from '../libs/utils';

const MODULE_NAME_BIZ = 'v1/erp-business-web/';
const baseUrl = `${MODULE_NAME_BIZ}`;// 本地服务请求地址
const protocol = window.location.protocol;
let resBaseUrl = `${protocol}//lanzhou.erp.dtp.linkdoc.com:9999`;// rd环境模拟地址
if (Location.host === 'erp.rd.linkdoc.com') {
  resBaseUrl = `${protocol}//lanzhou.erp.dtp.linkdoc.com:9999`;// rd环境模拟地址
} else if (Location.host === 'erp.dtp.linkdoc.com') {
  resBaseUrl = `${protocol}//erp.lanzhou.dtp.linkdoc.com:9999`;// 线上环境环境模拟地址
}
const instance = axios.create({
  baseURL: resBaseUrl,
});
export default {
  axios,
  getTotal(params) { //医保对账查询
    return instance.get(`/lanzhou/medical/getTotal?${utils.exchangeParams(params)}`);
  },
  checkTotal(params) { //医保对账对账接口
    return instance.get(`/lanzhou/medical/checkTotal?${utils.exchangeParams(params)}`);
  },
  getDetail(params) { //明细对账查询
    return instance.get(`/lanzhou/medical/getDetail?${utils.exchangeParams(params)}`);
  },
  checkDetail(params) { //明细对账对账
    return instance.get(`/lanzhou/medical/checkDetail?${utils.exchangeParams(params)}`);
  },
  signIn(params) { //签到
    return instance.post(`/lanzhou/medical/sign/in`, utils.exchangeParams(params));
  },
  signOut(params) { //签退
    return instance.post('/lanzhou/medical/sign/out', utils.exchangeParams(params));
  },
  print(params) { //打印调用接口获取打印数据
    return instance.post('/lanzhou/medical/getSettlementInfo', utils.exchangeParams(params));
  },
  getInsuranceDir(params) { //医保中心药品目录信息查询
    return instance.post('/lanzhou/medical/getDireInfo', utils.exchangeParams(params));
  },
  uploadDir(params) { //目录对照表上传页面中保存匹配
    return instance.post('/lanzhou/medical/directory/upload', utils.exchangeParams(params));
  },
  dirBackout(params) { //目录对照表上传页面中删除匹配
    return instance.post('/lanzhou/medical/directory/upload/undo', utils.exchangeParams(params));
  },
  getDireMatch(params) { //目录匹配查询接口
    return instance.post('/lanzhou/medical/getDireMatch', utils.exchangeParams(params));
  },
  dirCancel(params) { //目录撤销
    return instance.post('/lanzhou/medical/directory/undo', utils.exchangeParams(params));
  },
  refund(params) { //退款接口
    return instance.post('/lanzhou/medical/settlement/undo', utils.exchangeParams(params));
  },
  insuranceUser(params) { //验证读卡接口
    return instance.get(`/lanzhou/medical/readCard?${utils.exchangeParams(params)}`);
  },
};
